import {
  basicManager,
  desktopAuthManager,
  oauthManager,
  supabase,
} from '../utils/backend-auth.tsx';
import { backendAuthType, basicAuthEnabled } from '../utils/constants';

async function getSupabaseAuthHeader() {
  const session = await supabase?.auth.getSession();
  if (!session?.data.session) {
    return {};
  }

  return {
    Authorization: `Bearer ${session.data.session.access_token}`,
    'X-User-Id': session.data.session.user?.id,
  } as Record<string, string>;
}

async function getOauthAuthHeader() {
  const user = await oauthManager?.getUser();
  if (!user) {
    return;
  } else {
    // Refresh the token if it's expired
    if (user.expired) {
      oauthManager
        ?.signinSilent()
        .then((refreshedUser) => {
          if (!refreshedUser) {
            oauthManager?.removeUser();
            return;
          }
          return refreshedUser.access_token
            ? `Bearer ${refreshedUser.access_token}`
            : undefined;
        })
        .catch(() => {
          oauthManager?.removeUser();
          return;
        });
    }
  }
  return user?.access_token ? `Bearer ${user.access_token}` : undefined;
}

function getBasicAuthHeader() {
  const token = basicManager?.getAccessToken();
  if (!token) return undefined;
  return `Bearer ${token}`;
}

export async function getAuthHeaders(): Promise<Record<string, string>> {
  // Mixed auth + google login enabled -> no auth headers (Cookie-based),
  // so not included as a case here
  if (backendAuthType === 'oauth') {
    return {
      Authorization: await getOauthAuthHeader(),
    } as Record<string, string>;
  } else if (backendAuthType === 'supabase') {
    return await getSupabaseAuthHeader();
  } else if (basicAuthEnabled) {
    return {
      Authorization: getBasicAuthHeader(),
    } as Record<string, string>;
  } else if (backendAuthType === 'desktop') {
    return desktopAuthManager!.getAuthHeaders();
  }
  return {} as Record<string, string>;
}
